function parseEndTripMessage (xpertMessage) {
  const data = xpertMessage.split(',')

  return {
    date: data[1],
    totalDistanceTravelled: Number(data[2]),
    totalDistanceTravelledWithCruiseControl: Number(data[3]),
    totalFuelConsumption: Number(data[4]),
    totalFuelConsumptionInPTO: Number(data[5]),
    totalFuelConsumptionInIdle: Number(data[6]),
    totalFuelConsumptionDriving: Number(data[7]),
    totalFuelConsumptionWithCruiseControl: Number(data[8]),
    totalTimeWithCruiseControl: Number(data[9]),
    totalTimeInPTO: Number(data[10]),
    totalTimeInIdle: Number(data[11]),
    totalTimeDriving: Number(data[12]),
    totalTimeWithIgnitionKeyOnly: Number(data[13]),
    totalEngineHours: Number(data[14])
  }
}

function parseCanDriverStyleMessage (xpertMessage) {
  const data = xpertMessage.split(',')

  return {
    date: data[1],
    totalFuelConsumptionInEcoRange: Number(data[2]),
    totalTimeInEcoRange: Number(data[3]),
    totalDistanceInEcoRange: Number(data[4]),
    totalFuelConsumptionWithClutchPressed2: Number(data[5]),
    totalTimeWithClutchPressed2: Number(data[6]),
    totalDistanceWithClutchPressed2: Number(data[7]),
    totalFuelConsumptionWithCruiseControlAndAccelerator2: Number(data[8]),
    totalTimeWithCruiseControlAndAccelerator2: Number(data[9]),
    totalDistanceWithCruiseControlAndAccelerator2: Number(data[10]),
    totalNumberOfBrakes: Number(data[11]),
    totalNumberOfHarshBrakes: Number(data[12]),
    totalNumberOfHarshAccelerations: Number(data[13]),
    totalTimeWithHighRpmAndTorque: Number(data[14]),
    totalTimeWithHighTorque: Number(data[15]),
    totalTimeWithHighEngineTemperature: Number(data[16]),
    totalFuelConsumptionWithHighRpmAndTorque: Number(data[17]),
    totalDistanceWithHighRpmAndTorque: Number(data[18])
  }
}

function getEndTripMessages (xpertMessages) {
  return xpertMessages.map(xpert => (Array.isArray(xpert) ? xpert.split(';').find(m => m.startsWith('3')) : (xpert.startsWith('3') ? xpert : undefined))).flat().filter(a => a)
}

function getCanDriverStyleMessages (xpertMessages) {
  return xpertMessages.map(xpert => Array.isArray(xpert) ? xpert.split(';').find(m => m.startsWith('4')) : (xpert.startsWith('4') ? xpert : undefined)).flat().filter(a => a)
}

exports.parseEndTripMessage = parseEndTripMessage
exports.getEndTripMessages = getEndTripMessages
exports.parseCanDriverStyleMessage = parseCanDriverStyleMessage
exports.getCanDriverStyleMessages = getCanDriverStyleMessages
